import { CurrentUserModel } from './../../../models/account-ledger.model';
import { AuthService } from './../../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AccountDeliveryAddress, SuburbList, CartBillingAndShippings, PostcodeList } from '../../../models/account-delivery-address';
import { CommonService } from '../../../services/common.service';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { StateModel } from '../../../models/account-ledger.model';
import { CheckOutService } from '../../../services/checkout.service';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { CartDetailViewModel } from '../../../models/cart-item.model';
import { NgbCalendar, NgbDateStruct, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ShippingAddressViewModel } from '../../../models/shopping-cart.model';
import { CheckoutViewModel, CheckoutStatusModel, ShippingAddress } from '../../../models/check-out.model';
import { DOCUMENT } from '@angular/common';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { getShoppingCartView } from '../../../reducers/shoppingcart.reducer';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MyAccountService } from './../../../services/myAccount.service';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-shipping-address',
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('500ms', style({ opacity: 0 }))
      ])
    ]
    )
  ],
  templateUrl: './shipping-address.component.html',
  styleUrls: ['./shipping-address.component.css']
})
export class ShippingAddressComponent implements OnInit, OnDestroy {

  setFullWindow: false;
  title = 'Delivery Location';
  subscriptionRoute: Subscription;
  cartId: string;
  cartName: string;
  deliveryAddressList: AccountDeliveryAddress[];
  selectedAddress: AccountDeliveryAddress;
  collect = false
  addressFormGroup: FormGroup;
  shppingForm: FormGroup;
  stateList: string[];
  sendAddressForm = true;
  addressIsEdited = false;
  containsDirectShippingProducts = false;
  addAddressBook = false;
  chooseDate: NgbDateStruct = { day: this.calendar.getToday().day, month: this.calendar.getToday().month, year: this.calendar.getToday().year };
  shippingAddressModel: ShippingAddressViewModel;
  addressBookError = false;
  subData: Array<Object> = new Array<Object>();
  inputValue: string;
  checkoutViewModel: CheckoutViewModel;
  static DESIRED_DATE_RANGE = 14;
  public minDate: NgbDate;
  public maxDate: NgbDate;
  addressRadioButton = true;
  loadContent = false;
  warehouseDetails:any;
  selectedWarehouse:any;
  serial: string;

  backto: string;

  quoteId: string;

  checkoutStatus: CheckoutStatusModel;

  currentUserModel: CurrentUserModel;

  filteredPostCode: SuburbList[];
  filteredSub: SuburbList[];
  filteredPostCodeFromAPI: PostcodeList[];
  filteredSubFromAPI: PostcodeList[];
  public hasOutOfStock = false; 
  suburbValidateCheck : string;
  postCodeValidateCheck : string;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  account_validation_messages: any = {
    'companyName': [
      { class: 'companyNameValidate', message: 'Please enter company name' }
    ],
    'attnOrRef': [
      { class: 'attnOrRefValidate', message: 'Please enter attn or ref' }
    ],
    'addressLine1': [
      { class: 'addressLine1Validate', message: 'Please enter address' }
    ],
    'suburb': [
      { class: 'suburbValidate', message: 'Please enter suburb' }
    ],
    'state': [
      { class: 'stateValidate', message: 'Please enter state' }
    ],
    'postcode': [
      { class: 'postcodeValidate', message: 'Please enter postcode' }
    ],
    'phone': [
      { class: 'phoneValidate', message: 'Please enter phone' }
    ]
  };

  @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;
  shippingMethodControl = new FormControl("delivery");


  public locations: any = [{ name: 'Delivery', value: 'delivery' }];
  public getWareHouseDetails: any;
  public isPickUp = false;
  constructor(
    private router: Router
    , private activatedRoute: ActivatedRoute
    , private formBuilder: FormBuilder
    , private commonService: CommonService
    , private shoppingCartService: ShoppingCartService
    , private checkOutService: CheckOutService
    , public calendar: NgbCalendar
    , private checkoutService: CheckOutService
    , private authService: AuthService
    , private accountService: MyAccountService,

    private store: Store<AppState>
    , @Inject(DOCUMENT) private _document: Document) {
    this.initialAddress();

  }

  ngOnInit() {

    this.loadContent = false;
    this.commonService.getWarehouseList().pipe(takeUntil(this.ngUnsubscribe)).subscribe(locations => {
      this.getWareHouseDetails = locations;
      this.warehouseDetails=locations
      this.locations = [...this.locations, ...locations.map(l => {
        return { name: l.out_whse_description, value: l.out_whse_code, }
      })]
    });
    this.addressIsEdited = false;
    $('.page-contents').animate({
      scrollLeft: ($('#levelOne').outerWidth() + $('#cart-summary').outerWidth())
    }, 400);
    this.maxDate = this.calendar.getNext(this.calendar.getToday(), 'd', ShippingAddressComponent.DESIRED_DATE_RANGE);
    this.minDate = new NgbDate(this.calendar.getToday().year, this.calendar.getToday().month, this.calendar.getToday().day);

    this.subscriptionRoute = this.activatedRoute.parent.url
      .subscribe(value => {
        this.cartId = value.length > 1 ? value[1].path : '';
        this.cartName = value.length > 1 ? value[2].path : '';
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });

    this.authService.getLoginInfo().subscribe((model: CurrentUserModel) => {
      this.currentUserModel = model;
    });

    this.activatedRoute.parent.parent.parent.paramMap.pipe(
      switchMap((params) => {
        return this.activatedRoute.parent.parent.paramMap.pipe(
          map((param) => {
            return {
              quoteId: params.get('sku'),
              serial: param.get('serial'),
            }
          })
        )
      })
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      this.quoteId = res.quoteId;
      this.serial = res.serial;
      if (this.quoteId) {
        this.backto = 'quote';
      } else if (this.serial) {
        this.backto = 'renewal';
      } else {
        this.backto = 'cart';
      }
    })
    this.checkOutService.GetCartBillingNShipping(this.cartId).subscribe((res: CartBillingAndShippings) => {

      if (res) {
        if (res.contactMobile) {
          this.addressFormGroup.get('phone').setValue(res.contactMobile)
        }
        if (res.contactEmail) {
          this.addressFormGroup.get('email').setValue(res.contactEmail)
        }
        if (res.freightMethod) {          
          const freightMethod = this.locations.find((item) => item.value == res.freightMethod);
          this.shippingMethodControl.setValue(freightMethod?.value)
          this.isPickUp = true;
        }
        if (res.freightMethod){
          const freightMethodValue = this.locations.find((item) => item.value === res.freightMethod);
          this.addressFormGroup.get('deliveryType')?.setValue(freightMethodValue?.value);       
        }
        let deliveryValue = localStorage.getItem('DeliveryMethod')
        if(deliveryValue && deliveryValue!=='null'){
          const freightMethod = this.locations.find((item) => item.value == deliveryValue);
          this.addressFormGroup.get('deliveryType')?.setValue(freightMethod?.value);
          this.warehouseDetails?.map((loc)=>{
            if(loc?.out_whse_code === freightMethod?.value){
              this.selectedWarehouse = loc
            }
          })  
          this.collect = (deliveryValue !== 'delivery')?true:false;
          this.addressFormGroup.get('collectTheOrder')?.setValue(this.collect);
          this.isPickUp = true;
        }else {
          this.addressFormGroup.get('deliveryType')?.setValue("");
          this.collect = false;
          this.addressFormGroup.get('collectTheOrder')?.setValue(this.collect);
          this.isPickUp = false;
        }
        
        // if (res.willBeCollected?.toLowerCase() === 'yes') {
        //   this.collect = true;
        //   this.addressFormGroup.get('collectTheOrder').setValue(true);
        // } else {
        //   this.collect = false;
        //   this.addressFormGroup.get('collectTheOrder').setValue(false);
        // }
        if (res.partShipped?.toLowerCase() === 'yes') {
          this.addressFormGroup.get('partShipTheOrder').setValue(true);
        } else {
          this.addressFormGroup.get('partShipTheOrder').setValue(false);
        }
        if (res.requestedShippingDate) {
          const date = new Date(res.requestedShippingDate);
          this.chooseDate = { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() };
          this.addressFormGroup.get('shippingDate').setValue(this.chooseDate);
        }
        this.checkOutService.currentCheckoutViewModel.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CheckoutViewModel) => {
          if (res) {
            this.checkoutViewModel = res;
            if (this.checkoutViewModel.tenantDetailsRequired === 'NO') {
              this.checkoutStatus = {
                currentStep: 'ADDRESS',
                firstStep: this.checkoutViewModel.firstStep,
                collectOrder: this.collect,
                hasChosenCheckout: true,
                tenantDetailsRequired: 'NO'
              };
            } else {
              this.checkoutStatus = {
                currentStep: 'ADDRESS',
                firstStep: this.checkoutViewModel.firstStep,
                collectOrder: this.collect,
                hasChosenCheckout: true,
                tenantDetailsRequired: 'YES'
              };

            }
            this.checkoutService.emitChange(this.checkoutStatus);
          } else {
            //redirect to my cart on refresh
            this.router.navigateByUrl(this.router.url);
          }
        });
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

    this.checkOutService.editAddressWatch
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: AccountDeliveryAddress) => {
          if (!this.commonService.isEmpty(res)) {
            this.addressFormGroup.get('addressGroup.companyName').setValue(res.companyName);
            this.addressFormGroup.get('addressGroup.attnOrRef').setValue(res.attnOrRef);       
            this.addressFormGroup.get('addressGroup.addressLine1').setValue(res.addressLine1);
            this.addressFormGroup.get('addressGroup.addressLine2').setValue(res.addressLine2);
            this.addressFormGroup.get('addressGroup.addressLine3').setValue(res.addressLine3);
            this.addressFormGroup.get('addressGroup.addressLine4')?.setValue(res?.addressLine4);
            this.addressFormGroup.get('addressGroup.suburb').setValue(res.suburb);
            this.addressFormGroup.get('addressGroup.state').setValue(res.state ? res.state.toUpperCase() : "");
            this.addressFormGroup.get('addressGroup.postcode').setValue(res.postcode);
            this.addressFormGroup.get('addressGroup.phone').setValue(res.phone);
            this.addressFormGroup.get('addressGroup.naType').setValue(res.naType);
            this.addressFormGroup.get('addressGroup.action').setValue(res.action);
            this.addressFormGroup.get('addressGroup.combinedAddress').setValue(res.combinedAddress);
          }
        },
        complete: () => this.loadContent = true
      });

    this.checkOutService.selectLocationWatch
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: AccountDeliveryAddress) => {
          if (!this.commonService.isEmpty(res)) {
            this.addressFormGroup.get('addressGroup.suburb').setValidators([]);
            this.addressFormGroup.get('addressGroup.postcode').setValidators([]);       
            this.addressFormGroup.get('addressGroup.companyName').setValue(res.companyName);
            this.addressFormGroup.get('addressGroup.attnOrRef').setValue(res.attnOrRef);
            this.addressFormGroup.get('addressGroup.addressLine1').setValue(res.addressLine1);
            this.addressFormGroup.get('addressGroup.addressLine2').setValue(res.addressLine2);
            this.addressFormGroup.get('addressGroup.addressLine3').setValue(res.addressLine3);
            this.addressFormGroup.get('addressGroup.addressLine4')?.setValue(res?.addressLine4);
            this.addressFormGroup.get('addressGroup.suburb').setValue(res.suburb);
            this.addressFormGroup.get('addressGroup.state').setValue(res.state ? res.state.toUpperCase() : "");
            this.addressFormGroup.get('addressGroup.postcode').setValue(res.postcode);
            this.addressFormGroup.get('addressGroup.phone').setValue(res.phone);
            this.addressFormGroup.get('addressGroup.naType').setValue(res.naType);
            this.addressFormGroup.get('addressGroup.action').setValue(res.action);
            this.addressFormGroup.get('addressGroup.combinedAddress').setValue(res.combinedAddress);
            this.addressIsEdited = true;    
          }
        },
        complete: () => this.loadContent = true
      });

    this.checkOutService.dropdownAddress
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (val: AccountDeliveryAddress) => {
          this.selectedAddress = val;
          this.checkOutService.monitorEditAddress(this.selectedAddress);
          this.addressFormGroup.get('addressGroup.companyName').setValue(val.companyName);
          this.addressFormGroup.get('addressGroup.attnOrRef').setValue(val.attnOrRef);    
          this.addressFormGroup.get('addressGroup.addressLine1').setValue(val.addressLine1);
          this.addressFormGroup.get('addressGroup.addressLine2').setValue(val.addressLine2);
          this.addressFormGroup.get('addressGroup.addressLine3').setValue(val.addressLine3);
          this.addressFormGroup.get('addressGroup.addressLine4')?.setValue(val?.addressLine4);
          this.addressFormGroup.get('addressGroup.suburb').setValue(val.suburb);
          this.addressFormGroup.get('addressGroup.state').setValue(val.state ? val.state.toUpperCase() : "");
          this.addressFormGroup.get('addressGroup.postcode').setValue(val.postcode);
          this.addressFormGroup.get('addressGroup.phone').setValue(val.phone);
          this.addressFormGroup.get('addressGroup.naType').setValue(val.naType);
          this.addressFormGroup.get('addressGroup.action').setValue(val.action);
          this.addressFormGroup.get('addressGroup.combinedAddress').setValue(val.combinedAddress);
        }
      });

    this.shoppingCartService.getState().subscribe((res: StateModel) => {
      this.stateList = res.states;
    },
      (error: any) => {
        console.error(error);
      });



    this.store.select(getShoppingCartView).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if (res.items) {
        res.items.filter(x => x.freightPolicy && x.freightPolicy.toUpperCase() === 'D').length ? this.containsDirectShippingProducts = true : this.containsDirectShippingProducts = false;
      }
    });

    // this.shoppingCartService
    //   .getAllItemsFromShoppingCart(this.cartId, false)
    //   .subscribe((res: CartDetailViewModel[]) => {
    //     res.filter(x => x.freightPolicy && x.freightPolicy.toUpperCase() === 'D').length ? this.containsDirectShippingProducts = true : this.containsDirectShippingProducts = false;
    //   },
    //     (error: any) => {
    //       console.error(error);
    //       this.loadContent = true;
    //     });

    this.checkOutService.GetAddressView(this.commonService.toNumber(this.cartId)).subscribe((value: ShippingAddress) => {
      this.loadContent = true;
      if (value) {
        if (!this.addressIsEdited) {
          this.addressFormGroup.get('addressGroup.companyName').setValue(value.companyName);
          this.addressFormGroup.get('addressGroup.attnOrRef').setValue(value.attnRef);        
          this.addressFormGroup.get('addressGroup.addressLine1').setValue(value.addressLine1);        
          this.addressFormGroup.get('addressGroup.addressLine2').setValue(value.addressLine2);
          this.addressFormGroup.get('addressGroup.addressLine3').setValue(value.addressLine3);
          this.addressFormGroup.get('addressGroup.addressLine4')?.setValue(value?.addressLine4);
          this.addressFormGroup.get('addressGroup.suburb').setValue(value.suburb);
          this.addressFormGroup.get('addressGroup.state').setValue(value.state ? value.state.toUpperCase() : "");
          this.addressFormGroup.get('addressGroup.postcode').setValue(value.postcode);
          this.addressFormGroup.get('addressGroup.phone').setValue(value.phone);
          this.addressFormGroup.get('addressGroup.naType').setValue(value.naType);
          this.addressFormGroup.get('addressGroup.action').setValue('');
          this.addressFormGroup.get('addressGroup.combinedAddress').setValue('');
        }
      }
    },
      (error: any) => {
        console.error(error);
      });
  }
  public changeShippingMethod() {
    if (this.shippingMethodControl.value == 'delivery') {
      this.isPickUp = false;
      localStorage.setItem('DeliveryMethod', null)
    } else {
      this.isPickUp = true;
      localStorage.setItem('DeliveryMethod', this.shippingMethodControl.value)
    }
  }

  /*
  * this method is used for call when delivery type changed
  */
  public changeDeliveryMethod(event) {
    this.warehouseDetails?.map((loc)=>{
      if(loc?.out_whse_code === event?.value){
        this.selectedWarehouse = loc
      }
    })
    let deliveryControlValue = this.addressFormGroup.get('deliveryType')?.value;
    if(deliveryControlValue && deliveryControlValue === 'delivery'){
      this.isPickUp = false;
      this.selectedWarehouse=undefined  
      localStorage.setItem('DeliveryMethod', null)
    }else {
      this.isPickUp = true;
      localStorage.setItem('DeliveryMethod', deliveryControlValue)
      // now we to check available stock for selected warehouse
      this.loadContent = false;
      this.shoppingCartService.getAllItemsFromShoppingCart(this.cartId, true, deliveryControlValue)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (cartItemsResult) => {
              this.hasOutOfStock = cartItemsResult.every(cartItem => (cartItem.branch_AvailStock == "0"));
            if (this.hasOutOfStock) {
              const locationName = this.locations.find(l => l.value === deliveryControlValue)?.name;
              this.commonService.implementToast(`This location '${ locationName }' does not have enough stock for pickup`, 'Error');
            }
          },
          error: (error: string) => this.commonService.implementToast(error, "Error"),
          complete: () => this.loadContent = true
        });
    }
    this.collect = (deliveryControlValue !== 'delivery')?true:false;
    this.addressFormGroup.get('collectTheOrder').setValue(this.collect);
  }

  isNotValidField(path: string, validation: any): void {
    if (this.addressFormGroup.get(path).hasError('required')) {
      this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'right', 'error');
    }
  }

  getAddressGroup(): FormGroup {
    return this.formBuilder.group({

      companyName: new FormControl('', [Validators.required]),
      attnOrRef: new FormControl('', [Validators.required]),
      addressLine1: new FormControl('', [Validators.required]),
      addressLine2: new FormControl('', []),
      addressLine3: new FormControl('', []),
      addressLine4: new FormControl('', []),
      suburb: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      postcode: new FormControl('', [Validators.required]),
      phone: new FormControl('', [Validators.required]),
      naType: new FormControl(''),
      action: new FormControl('I'),
      combinedAddress: new FormControl('')
    });
  }
  isValidEmail(email: string): boolean {
    // You can implement a regular expression or use a library for more robust email validation
    // Here's a simple example:
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  emailOrPhoneRequiredValidator(group: FormGroup): { [key: string]: boolean } | null {
    const email = group.get('email').value;
    const phone = group.get('phone').value;

    // Check if either email or phone is filled in
    if (!email && !phone) {
      return { 'emailOrPhoneRequired': true };
    }

    // Reset the validation error if either email or phone is filled in
    return null;
  }

  isNumberKey(event: any) {
    const pattern = /^[0-9+]+$/;
    const inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;

    if (inputChar === '0' && inputValue.length === 0) {
      event.preventDefault();
    }

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  atLeastOneRequired(controlNames: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const controls = controlNames.map(name => control.get(name));

      if (controls.every(ctrl => !ctrl.value)) {
        return { atLeastOneRequired: true };
      }

      return null;
    };
  }

  moveToNext(): any {
    if (!this.collect) {
      if (this.sendAddressForm) {
        if (this.addressFormGroup.get('addressGroup').valid) {
          let flag = false;
          if (this.addressFormGroup.get('addressGroup.postcode').value.length < 4 ) {
            flag = true;
            this.commonService.showValidator('.postcodeValidate', 'Please input valid postcode', 'right', 'error');
          }         

          if (this.addressFormGroup.get('addressGroup.postcode')?.value.length > 0 || this.addressFormGroup.get('addressGroup.postcode').value?.postcode.length > 0 
          || this.addressFormGroup.get('addressGroup.suburb')?.value.length > 0 || this.addressFormGroup.get('addressGroup.suburb').value?.suburb.length > 0) {
            var suburbSearchKey = '';
            var postCodeSearchKey = '';   
            if(this.addressFormGroup.get('addressGroup.postcode')?.value != null || this.addressFormGroup.get('addressGroup.postcode')?.value?.postcode != null){
               suburbSearchKey = '';              
               postCodeSearchKey = this.addressFormGroup.get('addressGroup.postcode')?.value?.postcode || this.addressFormGroup.get('addressGroup.postcode')?.value;
            }
           else if (this.addressFormGroup.get('addressGroup.suburb')?.value != null || this.addressFormGroup.get('addressGroup.suburb')?.value?.suburb != null){
            suburbSearchKey = this.addressFormGroup.get('addressGroup.suburb')?.value?.suburb || this.addressFormGroup.get('addressGroup.suburb')?.value;
            postCodeSearchKey = '';
           }
            this.authService.GetPostCodeList(suburbSearchKey, postCodeSearchKey).
              subscribe((res: any) => {
                this.filteredSubFromAPI = res;   
                const selection: any = this.addressFormGroup.get('addressGroup.suburb')?.value?.suburb ||  this.addressFormGroup.get('addressGroup.suburb')?.value;
                const suburbList = this.filteredSubFromAPI?.map(s => s.suburb);                
                console.log(selection)   
                if (!this.filteredSubFromAPI?.length || (!suburbList.includes(selection.toUpperCase())))               
                    {
                     flag = true ;
                     this.commonService.showValidator('.suburbValidate', 'Please input valid suburb', 'right', 'error');
                }           
               
                                                
                if (!flag) {
                  this.loadContent = false;
                  this.addressFormGroup.get('addressGroup').get('action').setValue(this.addAddressBook ? 'I' : this.addressFormGroup.get('addressGroup').get('action').value);
                  const addressGroup = { ...this.addressFormGroup.get('addressGroup').value }                 
                  addressGroup.postcode = this.addressFormGroup.get('addressGroup.postcode')?.value?.postcode || this.addressFormGroup.get('addressGroup.postcode')?.value;
                  addressGroup.suburb = this.addressFormGroup.get('addressGroup.suburb')?.value?.suburb || this.addressFormGroup.get('addressGroup.suburb')?.value.toUpperCase();                  this.shippingAddressModel = {
                    shippingDate: this.chooseDate.day + '/' + this.chooseDate.month + '/' + this.chooseDate.year,
                    collectTheOrder: this.addressFormGroup.get('collectTheOrder').value ? this.addressFormGroup.get('collectTheOrder').value : false,
                    partShipTheOrder: this.addressFormGroup.get('partShipTheOrder').value ? this.addressFormGroup.get('partShipTheOrder').value : false,
                    addToAddressBook: this.addAddressBook,
                    cartId: this.commonService.toNumber(this.cartId),
                    addressGroup
                  };
                  this.checkOutService.setShippingAddress(this.shippingAddressModel).subscribe(res => {
                    this.addressIsEdited = false;
                    if (res.status) {
                      this.checkOutService.monitorPassModel(this.shippingAddressModel);
                      this.checkOutService.monitorSelectLocation(this.shippingAddressModel.addressGroup);
                      this.loadContent = true;

                      if ((this.shippingAddressModel.collectTheOrder === false) && this.checkoutViewModel?.firstStep === 'NOENDUSER' && this.checkoutViewModel?.containsDirectShippingProducts !== 'YES' && this.checkoutViewModel?.tenantDetailsRequired === 'NO') {
                        this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
                      } else if (this.shippingAddressModel.collectTheOrder === true && this.checkoutViewModel.firstStep === 'NOENDUSER' && this.checkoutViewModel.tenantDetailsRequired === 'NO') {
                        // NZ site is not using donation page
                        // if (this.currentUserModel.isAU) {
                        //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
                        // } else {
                        this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
                        // }
                      } else if (this.checkoutViewModel.tenantDetailsRequired === 'YES' && this.checkoutViewModel.firstStep === 'NOENDUSER') {
                        this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
                      } else {
                        this.router.navigate(['end-user'], { relativeTo: this.activatedRoute.parent });
                      }
                    } else {
                      this.commonService.showError('#moveToFreight', res.responseMessage, 'right');
                      this.loadContent = true;
                    }
                  },
                    (error: any) => {
                      console.error(error);
                    });
                }

            },
                (error: any) => {
                  flag = true;
                  this.commonService.showValidator('.suburbValidate', 'Please input valid suburb', 'right', 'error');
                  this.commonService.showValidator('.postcodeValidate', 'Please input valid postcode', 'right', 'error');
                  console.error(error);
                  this.loadContent = true;
                });      
          }    
          
         
        } else {
          this.isNotValidField('addressGroup.companyName', this.account_validation_messages.companyName);
          this.isNotValidField('addressGroup.attnOrRef', this.account_validation_messages.attnOrRef);
          this.isNotValidField('addressGroup.addressLine1', this.account_validation_messages.addressLine1);
          this.isNotValidField('addressGroup.suburb', this.account_validation_messages.suburb);
          this.isNotValidField('addressGroup.state', this.account_validation_messages.state);
          this.isNotValidField('addressGroup.postcode', this.account_validation_messages.postcode);
          this.isNotValidField('addressGroup.phone', this.account_validation_messages.phone);
        }
      } else {
        this.sendAddressForm = true;
        $('#pills-tab a[href="#ship-address"]').tab('show');
      }
    } else {
    const emailControl = this.addressFormGroup.get('email')?.value;
    const phoneControl = this.addressFormGroup.get('phone')?.value;
    const deliveryTypeControl = this.addressFormGroup.get('deliveryType')?.value;

    if(!deliveryTypeControl || deliveryTypeControl === 'delivery'){
      this.commonService.showValidator('.shippingValidate', 'Please select a valid shipping method', 'right', 'error');
      return false
    }

    
    if (this.addressFormGroup.hasError('emailOrPhoneRequired')) {
      // Show an error message or handle the validation error as needed
      this.commonService.showValidator('.emailValidate', 'Please enter valid email address', 'right', 'error');
       this.commonService.showValidator('.phoneValidate', 'Please enter valid phone number', 'right', 'error');
       return false;
    }
    if (emailControl && (this.isValidEmail(emailControl) == false)) {
      this.commonService.showValidator('.emailValidate', 'please enter valid email', 'right', 'error');
      return false;
    }

    let phoneControlValue = phoneControl?.toString();
    // if (phoneControlValue?.length > 0) {
    //   if (phoneControlValue?.length !== 10) {
    //     this.commonService.showValidator('.phoneValidate', 'phone length is minimun 10 digits', 'right', 'error');
    //     return false
    //   }
    // }

    if(!(deliveryTypeControl && (phoneControl || emailControl))) return false;
    let deliveryObject = this.getWareHouseDetails.find(obj => obj.out_whse_code === deliveryTypeControl)
    if(deliveryObject){
      this.addressFormGroup.get('addressGroup.addressLine1')?.setValue(deliveryObject?.out_whse_address01);
      this.addressFormGroup.get('addressGroup.addressLine2')?.setValue(deliveryObject?.out_whse_address02);
      this.addressFormGroup.get('addressGroup.addressLine3')?.setValue(deliveryObject?.out_whse_address03);
      this.addressFormGroup.get('addressGroup.addressLine4')?.setValue(deliveryObject?.out_whse_address04);
      this.addressFormGroup.get('addressGroup.postcode')?.setValue(deliveryObject?.out_whse_postcode);
      this.addressFormGroup.get('addressGroup.state')?.setValue(deliveryObject?.out_whse_state);
      this.addressFormGroup.get('addressGroup.phone')?.setValue(deliveryObject?.out_whse_phone);
    }
      const addressGroup = { ...this.addressFormGroup.get('addressGroup').value }
     /*  addressGroup.postcode = this.addressFormGroup.get('addressGroup.postcode')?.value?.postcode || '';
      addressGroup.suburb = this.addressFormGroup.get('addressGroup.suburb')?.value?.suburb || ''; */
      addressGroup.postcode = this.addressFormGroup.get('addressGroup.postcode')?.value?.postcode || this.addressFormGroup.get('addressGroup.postcode')?.value;
      addressGroup.suburb = this.addressFormGroup.get('addressGroup.suburb')?.value?.suburb || this.addressFormGroup.get('addressGroup.suburb')?.value.toUpperCase(); 
      this.shippingAddressModel = {
        shippingDate: this.chooseDate.day + '/' + this.chooseDate.month + '/' + this.chooseDate.year,
        collectTheOrder: this.addressFormGroup.get('collectTheOrder').value ? this.addressFormGroup.get('collectTheOrder').value : false,
        partShipTheOrder: this.addressFormGroup.get('partShipTheOrder').value ? this.addressFormGroup.get('collectTheOrder').value : false,
        addToAddressBook: false,
        cartId: this.commonService.toNumber(this.cartId),
        addressGroup,
        warehouseCode: deliveryObject?.out_whse_code?deliveryObject?.out_whse_code:localStorage.getItem('DeliveryMethod'),
        warehouseAddress :deliveryObject?.out_whse_code?deliveryObject?.out_whse_description:localStorage.getItem('DeliveryMethod'),
        notificationEmail: this.addressFormGroup.get('email').value,
        notificationPhone: this.addressFormGroup.get('phone').value,

      };
      this.checkOutService.setShippingAddress(this.shippingAddressModel).subscribe(res => {
        this.addressIsEdited = false;
        if (res.status) {
          this.checkOutService.monitorPassModel(this.shippingAddressModel);
          this.checkOutService.monitorSelectLocation(this.shippingAddressModel.addressGroup);
          this.loadContent = true;

          if ((this.shippingAddressModel.collectTheOrder === false) && this.checkoutViewModel.firstStep === 'NOENDUSER' && this.checkoutViewModel.containsDirectShippingProducts !== 'YES' && this.checkoutViewModel.tenantDetailsRequired === 'NO') {
            this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
          } else if (this.shippingAddressModel.collectTheOrder === true && this.checkoutViewModel.firstStep === 'NOENDUSER' && this.checkoutViewModel.tenantDetailsRequired === 'NO') {
            // NZ site is not using donation page
            // if (this.currentUserModel.isAU) {
            //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
            // } else {
              this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
            // }
          } else if (this.checkoutViewModel.tenantDetailsRequired === 'YES' && this.checkoutViewModel.firstStep === 'NOENDUSER') {
            // LoadSection("TENANT");
            this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
          } else {
            // LoadSection("ENDUSER");
            this.router.navigate(['end-user'], { relativeTo: this.activatedRoute.parent });
          }
        } else {
          this.commonService.showError('#moveToFreight', res.responseMessage, 'right');
        }
      },
        (error: any) => {
          console.error(error);
        });
    }
  }

  /* chooseAutoComplete(option: SuburbList): void {
    this.addressFormGroup.get('addressGroup.postcode').setValue(option);
    this.addressFormGroup.get('addressGroup.state').setValue(option.state);
    this.addressFormGroup.get('addressGroup.suburb').setValue(option);
  } */
  chooseAutoComplete(option: PostcodeList): void {
    this.addressFormGroup.get('addressGroup.postcode').setValue(option);
    this.addressFormGroup.get('addressGroup.state').setValue(option.state);
    this.addressFormGroup.get('addressGroup.suburb').setValue(option);
  }

 /*  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCode) {
      this.addressFormGroup.get('addressGroup.postcode').setValue(this.filteredPostCode.filter(option => option.state && option.postcode?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0]);
      this.addressFormGroup.get('addressGroup.state').setValue(this.filteredPostCode.filter(option => option.state && option.postcode?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0].state);
      this.addressFormGroup.get('addressGroup.suburb').setValue(this.filteredPostCode.filter(option => option.state && option.postcode?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0]);
    }
  } */
  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCodeFromAPI) {
      this.addressFormGroup.get('addressGroup.postcode').setValue(this.filteredPostCodeFromAPI.filter(option => option.state && option.postcode?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0]);
      this.addressFormGroup.get('addressGroup.state').setValue(this.filteredPostCodeFromAPI.filter(option => option.state && option.postcode?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0].state);
      this.addressFormGroup.get('addressGroup.suburb').setValue(this.filteredPostCodeFromAPI.filter(option => option.state && option.postcode?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0]);
    }
  } 

  /* chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSub) {
      this.addressFormGroup.get('addressGroup.postcode').setValue(this.filteredSub.filter(option => option.state && option.suburb?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0]);
      this.addressFormGroup.get('addressGroup.state').setValue(this.filteredSub.filter(option => option.state && option.suburb?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0].state);
      this.addressFormGroup.get('addressGroup.suburb').setValue(this.filteredSub.filter(option => option.state && option.suburb?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0]);
    }
  } */
  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSubFromAPI) {
      this.addressFormGroup.get('addressGroup.postcode').setValue(this.filteredSubFromAPI.filter(option => option.state && option.suburb?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0]);
      this.addressFormGroup.get('addressGroup.state').setValue(this.filteredSubFromAPI.filter(option => option.state && option.suburb?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0].state);
      this.addressFormGroup.get('addressGroup.suburb').setValue(this.filteredSubFromAPI.filter(option => option.state && option.suburb?.toLowerCase().startsWith(event.target.value?.toLowerCase()))[0]);
    }
  }

 /*  startFilterSub(): void {
    if (this.addressFormGroup.get('addressGroup.suburb').value.length > 2) {
      this.checkOutService.getSuburbList(this.addressFormGroup.get('addressGroup.suburb').value).subscribe((res: SuburbList[]) => {
        this.filteredSub = res;

        this.addressFormGroup.get('addressGroup.suburb').setValidators([Validators.required, this.RequireMatch(this.filteredSub)]);
        this.addressFormGroup.get('addressGroup.suburb').updateValueAndValidity();
        this.addressFormGroup.get('addressGroup.postcode').setValidators([Validators.required, this.RequireMatch(this.filteredSub)]);
        this.addressFormGroup.get('addressGroup.postcode').updateValueAndValidity();
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    }
  } */

  startFilterSub(): void {       
    this.addressFormGroup.get('addressGroup.suburb').setValidators([Validators.required]);
    this.addressFormGroup.get('addressGroup.suburb').updateValueAndValidity();
    if (this.addressFormGroup.get('addressGroup.suburb').value.length > 0) {
      var postCodeSearchKey = '';   
      this.authService.GetPostCodeList(this.addressFormGroup.get('addressGroup.suburb').value, postCodeSearchKey).
      subscribe((res:PostcodeList[]) => {
        this.filteredSubFromAPI = res;
        this.addressFormGroup.get('addressGroup.suburb').setValidators([Validators.required, this.RequireMatchForPostCodeFromAPI(this.filteredSubFromAPI)]);
        this.addressFormGroup.get('addressGroup.suburb').updateValueAndValidity();
        this.addressFormGroup.get('addressGroup.postcode').setValidators([Validators.required, this.RequireMatchForPostCodeFromAPI(this.filteredSubFromAPI)]);
        this.addressFormGroup.get('addressGroup.postcode').updateValueAndValidity();           
      },
        (error: any) => {
          console.error(error);  
          this.addressFormGroup.get('addressGroup.suburb').setValidators([Validators.required, this.RequireMatchForPostCodeFromAPI(this.filteredSubFromAPI)]);
          this.addressFormGroup.get('addressGroup.suburb').updateValueAndValidity();       
          this.loadContent = true;
        });
    }
    
  }

  /* startFilterPostcode(): void {
    if (this.addressFormGroup.get('addressGroup.postcode').value.length > 1) {
      this.checkOutService.getPostCodeList(this.addressFormGroup.get('addressGroup.postcode').value).subscribe((res: SuburbList[]) => {
        this.filteredPostCode = res;

        this.addressFormGroup.get('addressGroup.suburb').setValidators([Validators.required, this.RequireMatch(this.filteredPostCode)]);
        this.addressFormGroup.get('addressGroup.suburb').updateValueAndValidity();
        this.addressFormGroup.get('addressGroup.postcode').setValidators([Validators.required, this.RequireMatch(this.filteredPostCode)]);
        this.addressFormGroup.get('addressGroup.postcode').updateValueAndValidity();
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    }
  } */
  startFilterPostcode(): void {
    this.addressFormGroup.get('addressGroup.postcode').setValidators([Validators.required]);
    this.addressFormGroup.get('addressGroup.postcode').updateValueAndValidity();   
    if (this.addressFormGroup.get('addressGroup.postcode').value.length > 0) {
      var suburbSearchKey = ''; 
      this.authService.GetPostCodeList(suburbSearchKey, this.addressFormGroup.get('addressGroup.postcode').value).
      subscribe((res:PostcodeList[]) => {     
        this.filteredPostCodeFromAPI = res;
        this.addressFormGroup.get('addressGroup.suburb').setValidators([Validators.required, this.RequireMatchForPostCodeFromAPI(this.filteredPostCodeFromAPI)]);
        this.addressFormGroup.get('addressGroup.suburb').updateValueAndValidity();
        this.addressFormGroup.get('addressGroup.postcode').setValidators([Validators.required, this.RequireMatchForPostCodeFromAPI(this.filteredPostCodeFromAPI)]);
        this.addressFormGroup.get('addressGroup.postcode').updateValueAndValidity();       
        
      },
        (error: any) => {
          console.error(error); 
          this.addressFormGroup.get('addressGroup.postcode').setValidators([Validators.required, this.RequireMatchForPostCodeFromAPI(this.filteredPostCodeFromAPI)]);
          this.addressFormGroup.get('addressGroup.postcode').updateValueAndValidity();
          this.loadContent = true;
        });
    }
  } 
  onInputSub(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }

  onInputPostcode(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }

  collectOrder(): void {
    if (this.checkoutViewModel) {
      if (this.checkoutViewModel.containsDirectShippingProducts !== 'YES') {
        this.collect = !this.collect;
      } else {
        this.addressFormGroup.get('collectTheOrder').disable();
        this.addressFormGroup.get('collectTheOrder').setValue(false);
        this.collect = false;
      }
    }
    if (this.collect) {
      this.checkoutStatus = {
        currentStep: 'ADDRESS',
        firstStep: this.checkoutViewModel.firstStep,
        collectOrder: true,
        hasChosenCheckout: true,
        tenantDetailsRequired: this.checkoutViewModel.tenantDetailsRequired
      };
      this.checkoutService.emitChange(this.checkoutStatus);
    } else {
      this.checkoutStatus = {
        currentStep: 'ADDRESS',
        firstStep: this.checkoutViewModel.firstStep,
        collectOrder: false,
        hasChosenCheckout: true,
        tenantDetailsRequired: this.checkoutViewModel.tenantDetailsRequired
      };
      this.checkoutService.emitChange(this.checkoutStatus);
    }
  }

  addToAddressBook($event: any): void {
    this.addAddressBook = $event.checked;
  }

  selectLocation(): void {
    this.router.navigate(['select-location'], { relativeTo: this.activatedRoute });
    // this.router.navigate(['select-location'], { relativeTo: this.activatedRoute.parent });
  }

  setDispatchDate(): void {
    this.addressFormGroup.get('shippingDate').setValue(this.chooseDate);
  }



  initialAddress(): void {
    this.addressFormGroup = this.formBuilder.group({
      addressGroup: this.getAddressGroup(),
      collectTheOrder: new FormControl(false, [Validators.required]),
      addToAddressBook: new FormControl(false, [Validators.required]),
      partShipTheOrder: new FormControl(false, [Validators.required]),
      shippingDate: new FormControl(false, []),
      deliveryType: new FormControl('', [Validators.required]),
      phone: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required])
    }, { validator: this.emailOrPhoneRequiredValidator });
  }


  clearAllFields(): void {
    this.addressFormGroup.reset();
  }

  onDateSelect(event): void {
    this.chooseDate = { day: event.day, month: event.month, year: event.year };
    this.addressFormGroup.get('shippingDate').setValue(this.chooseDate);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  backtoCart() {
    this.checkOutService.monitorShowCartSummary('show');
    this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}`);
  }

  backtoRenewals() {
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent.parent });
    //this.router.navigateByUrl(`manageRenewalsNew/renewalDetails/${this.serial}`);
  }

  backtoQuotes() {
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent.parent });
    $('.combination-loader').animate(
      { scrollLeft: (250 + $('#price-list-detail').width()) }, 100)

  }

  displayWithSuburb(obj?: any): string | undefined {
    if (typeof obj === 'object') {
      return obj ? obj.suburb : undefined ;
    }
    else{
      return obj;
    }
    
  }

  displayWithPostcode(obj?: any): string | undefined {
    if (typeof obj === 'object') {
    return obj ? obj.postcode : undefined;
    }
    else{
      return obj;
    }
  }

  private RequireMatch(filteredSubs: SuburbList[]) {
    return (control: AbstractControl) => {
      const selection: any = control.value;
      const suburbList = filteredSubs?.map(s => s.suburb)
      const postcodeList = filteredSubs?.map(s => s.postcode)
      console.log(selection)
      if (
          !filteredSubs?.length ||
          typeof selection === 'string' ||
          (!suburbList.includes(selection.suburb) || (!postcodeList.includes(selection.postcode) && !postcodeList.includes(selection.postcode)))
      ) {
          return { incorrect: true };
      }
      return null;
    };
   
  }
  private RequireMatchForPostCodeFromAPI(filteredSubs: PostcodeList[]) {
    return (control: AbstractControl) => {
      const selection: any = control.value;
      const suburbList = filteredSubs?.map(s => s.suburb)
      const postcodeList = filteredSubs?.map(s => s.postcode)
      if (
          !filteredSubs?.length ||
          typeof selection === 'string' ||
          (!suburbList.includes(selection.suburb) || (!postcodeList.includes(selection.postcode) && !postcodeList.includes(selection.postcode)))
      ) {
          return { incorrect: true };
      }
      return null;
    };
   
  }

  close() {
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });
  }

  omit_nonprintable_char(event: any) {
    event.target.value = this.commonService.omit_nonprintable_char(event.target.value);
    if (event.target.id == "addressLine1") {
      this.addressFormGroup.get('addressGroup.addressLine1').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine2") {
      this.addressFormGroup.get('addressGroup.addressLine2').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine3") {
      this.addressFormGroup.get('addressGroup.addressLine3').setValue(event.target.value);
    }
  }
}
